export default __webpack_public_path__ + "static/media/placeholder_business04-fr-web.7ec2eea6.png";